import React from "react";

import TextInput from "../../shared/components/forms/TextInput";
import Button from "../../shared/components/forms/Button";

export default function EmailForm({
  email,
  emailFormError,
  onChange,
  onSubmit,
  disabled,
  onFocusEmailAddress = () => {},
}) {

  return (
    <div className="ds-card">
      <section className="cardSection">
        <TextInput
          error={emailFormError}
          label="Email Address"
          name="email"
          type="email"
          value={email}
          onChange={onChange}
          onFocus={onFocusEmailAddress}
        />
      </section>
      <Button
        className="--full"
        onClick={onSubmit}
        label="Save Changes"
        disabled={disabled}
        test="save-changes-user-email"
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/user/components/EmailForm.js